import React from 'react';

import './Backdrop.scss';

interface Props {
    onClick: () => void;
    visible: boolean;
    nested?: boolean;
    noOpacity?: boolean;
    dark?: boolean;
}

const Backdrop: React.FunctionComponent<Props> = (props) => {
    const nested = Boolean(props.nested);
    const noOpacity = Boolean(props.noOpacity);

    // do not return before this effect, otherwise we might miss important checks
    React.useEffect(() => {
        window.addEventListener('keydown', closeOnEscapePress, false);

        const htmlAndBody = document.querySelectorAll('html, body') as NodeListOf<HTMLElement>;
        if (nested === false) {
            if (props.visible) {
                htmlAndBody.forEach((element) => (element.style.overflowY = 'hidden'));
            } else {
                htmlAndBody.forEach((element) => (element.style.overflowY = 'initial'));
            }
        }

        if (props.visible) {
            htmlAndBody.forEach((element) => element.classList.add('lombagine-modal-open'));
        } else {
            htmlAndBody.forEach((element) => element.classList.remove('lombagine-modal-open'));
        }

        // returned function will be called on component unmount
        return () => {
            window.removeEventListener('keydown', closeOnEscapePress);
            if (nested === false) {
                htmlAndBody.forEach((element) => (element.style.overflowY = 'initial'));
            }
            htmlAndBody.forEach((element) => element.classList.remove('lombagine-modal-open'));
        };
    }, [props.visible, props.nested]);

    if (props.visible === false) {
        return null;
    }

    const closeOnEscapePress = (event: KeyboardEvent) => {
        if (event.key === 'Escape' && typeof props.onClick === 'function') {
            props.onClick();
        }
    };

    const clickHandler = () => {
        // invoke optional additional callback function
        if (typeof props.onClick === 'function') {
            props.onClick();
        }
    };

    return (
        <div
            className={
                'lombagine-modal-backdrop' +
                (noOpacity ? ' no-opacity' : '') +
                (props.dark === true ? ' lombagine-modal-backdrop--dark' : '')
            }
            tabIndex={-1}
            onClick={clickHandler}
        />
    );
};

export default Backdrop;
